import { IconsProps } from '@/types/shared'

const BusinessPerformanceIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {/* Combined bar and line chart for business performance */}
                <line x1="12" y1="20" x2="12" y2="10" />
                <line x1="18" y1="20" x2="18" y2="4" />
                <line x1="6" y1="20" x2="6" y2="16" />
                <polyline points="22 12 18 8 14 12 10 8 6 12 2 8" />
            </svg>
        </div>
    )
}

export default BusinessPerformanceIcons
